(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const applyAccordionState = () => {
      const showAccordionOnMobile =
        document.querySelector('[data-show-accordion]')?.getAttribute('data-show-accordion') === 'true';
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      document.querySelectorAll('details[data-footer-accordions]').forEach((el) => {
        if (showAccordionOnMobile && isMobile) {
          el.removeAttribute('open', '');
        } else if (!showAccordionOnMobile && isMobile) {
          // Do not show accordion on mobile if setting disallows
          el.setAttribute('open', true);
        } else if (!isMobile) {
          // On desktop, always open accordions
          el.setAttribute('open', '');
        }
      });
    };
    applyAccordionState();
    window.addEventListener('resize', applyAccordionState);
    document.addEventListener('shopify:section:load', (event) => {
      // Apply accordion state when a new section is loaded
      applyAccordionState();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-comparison"] && !Shopify.designMode) return;
  try {
    
  /*
  class ImageComparison extends HTMLElement {
    constructor() {
      super();
      this.active = false;
    }

    get iconButtons() {
      return this.querySelectorAll('[data-drag-button]');
    }

    get layout() {
      return this.getAttribute('data-layout');
    }

    get bounding() {
      return this.getBoundingClientRect();
    }

    addClasses() {
      lockBodyScroll();
      this.active = true;
      this.iconButtons.forEach((btn) => btn.classList.add('animating'));
    }

    removeClasses() {
      unlockBodyScroll();
      this.active = false;
      this.iconButtons.forEach((btn) => btn.classList.remove('animating'));
    }

    init() {
      const iconButtons = this.iconButtons;
      if (!iconButtons.length) {
        // console.error('Error: No [data-drag-button] found inside <image-comparison>.');
        return;
      }

      iconButtons.forEach((btn) => {
        btn.addEventListener('mousedown', this.addClasses.bind(this));
        btn.addEventListener('touchstart', this.addClasses.bind(this));
      });

      // document.body.addEventListener('mouseup', this.removeClasses.bind(this));
      // document.body.addEventListener('mouseleave', this.removeClasses.bind(this));
      document.body.addEventListener('touchend', this.removeClasses.bind(this));
      document.body.addEventListener('touchcancel', this.removeClasses.bind(this));

      document.body.addEventListener('mousemove', (e) => {
        if (!this.active) return;
        let x =
          this.layout === 'horizontal' ? e.pageX - this.bounding.left : e.pageY - (this.bounding.top + window.scrollY);
        this.movecurs(x);
      });

      document.body.addEventListener('touchmove', (e) => {
        if (!this.active) return;
        let x =
          this.layout === 'horizontal'
            ? e.touches[0].pageX - this.bounding.left
            : e.touches[0].pageY - (this.bounding.top + window.scrollY);
        this.movecurs(x);
      });

      // Intersection Observer for triggering animation
      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              //this.animateDrag();

              observer.disconnect();
            } else {
            }
          });
        },
        { threshold: 0.8 }
      );

      observer.observe(this);
    }

    movecurs(x) {
      const distance = this.layout === 'horizontal' ? this.clientWidth : this.clientHeight;
      const max = distance - 20;
      const min = 20;
      const mouseX = Math.max(min, Math.min(x, max));
      const mousePercent = (mouseX * 100) / distance;

      this.iconButtons.forEach((btn) => {
        if (this.layout === 'horizontal') {
          btn.style.left = mousePercent + '%';
        } else {
          btn.style.top = mousePercent + '%';
        }
      });

      this.style.setProperty('--drag-position', mousePercent + '%');
    }

    animateDrag() {
      const distance = this.layout === 'horizontal' ? this.clientWidth : this.clientHeight;
      const max = distance - 20;
      const min = 20;
      let start = performance.now();
      const totalDuration = 2000;
      let currentPos = min;

      const animateRight = (time) => {
        const progress = (time - start) / totalDuration;
        if (progress < 1) {
          currentPos = min + (max - min) * progress;
          this.movecurs(currentPos);
          requestAnimationFrame(animateRight);
        } else {
          this.movecurs(max);
          setTimeout(() => {
            this.animateToMiddle();
          }, 500);
        }
      };

      requestAnimationFrame(animateRight);
    }

    animateToMiddle() {
      const distance = this.layout === 'horizontal' ? this.clientWidth : this.clientHeight;
      const max = distance - 20;
      const min = 20;
      const middle = (min + max) / 2;
      let start = performance.now();
      const totalDuration = 1000;

      const animateMiddle = (time) => {
        const progress = (time - start) / totalDuration;
        if (progress < 1) {
          const currentPos = max - (max - middle) * progress;
          this.movecurs(currentPos);
          requestAnimationFrame(animateMiddle);
        } else {
          this.movecurs(middle);
        }
      };

      requestAnimationFrame(animateMiddle);
    }

    connectedCallback() {
      this.init();
    }
  }

  customElements.define('image-comparison', ImageComparison);

  */
  // Helper functions for body scroll control

  class ImageComparison extends HTMLElement {
    constructor() {
      super();
      this.active = false;

      // Bind all event handlers once
      this.boundAddClasses = this.addClasses.bind(this);
      this.boundRemoveClasses = this.removeClasses.bind(this);
      this.boundMouseMove = this.handleMouseMove.bind(this);
      this.boundTouchMove = this.handleTouchMove.bind(this);
    }

    get iconButtons() {
      return this.querySelectorAll('[data-drag-button]');
    }

    get layout() {
      return this.getAttribute('data-layout') || 'horizontal';
    }

    get bounding() {
      return this.getBoundingClientRect();
    }

    addClasses() {
      lockBodyScroll();
      this.active = true;
      this.iconButtons.forEach((btn) => btn.classList.add('animating'));

      // Add temporary event listeners
      document.addEventListener('mousemove', this.boundMouseMove);
      document.addEventListener('touchmove', this.boundTouchMove, { passive: false });
      document.addEventListener('mouseup', this.boundRemoveClasses);
      document.addEventListener('mouseleave', this.boundRemoveClasses);
      document.addEventListener('touchend', this.boundRemoveClasses);
      document.addEventListener('touchcancel', this.boundRemoveClasses);
    }

    removeClasses() {
      unlockBodyScroll();
      this.active = false;
      this.iconButtons.forEach((btn) => btn.classList.remove('animating'));

      // Clean up temporary event listeners
      document.removeEventListener('mousemove', this.boundMouseMove);
      document.removeEventListener('touchmove', this.boundTouchMove);
      document.removeEventListener('mouseup', this.boundRemoveClasses);
      document.removeEventListener('mouseleave', this.boundRemoveClasses);
      document.removeEventListener('touchend', this.boundRemoveClasses);
      document.removeEventListener('touchcancel', this.boundRemoveClasses);
    }

    handleMouseMove(e) {
      if (!this.active) return;
      const x =
        this.layout === 'horizontal' ? e.pageX - this.bounding.left : e.pageY - (this.bounding.top + window.scrollY);
      this.movecurs(x);
    }

    handleTouchMove(e) {
      if (!this.active) return;
      e.preventDefault(); // Prevent scrolling while dragging
      const touch = e.touches[0];
      const x =
        this.layout === 'horizontal'
          ? touch.pageX - this.bounding.left
          : touch.pageY - (this.bounding.top + window.scrollY);
      this.movecurs(x);
    }

    movecurs(x) {
      const distance = this.layout === 'horizontal' ? this.clientWidth : this.clientHeight;
      const max = distance - 20;
      const min = 20;
      const mouseX = Math.max(min, Math.min(x, max));
      const mousePercent = (mouseX * 100) / distance;

      this.iconButtons.forEach((btn) => {
        if (this.layout === 'horizontal') {
          btn.style.left = mousePercent + '%';
        } else {
          btn.style.top = mousePercent + '%';
        }
      });

      this.style.setProperty('--drag-position', mousePercent + '%');
    }

    init() {
      const iconButtons = this.iconButtons;
      if (!iconButtons.length) return;

      // Add permanent event listeners
      iconButtons.forEach((btn) => {
        btn.addEventListener('mousedown', this.boundAddClasses);
        btn.addEventListener('touchstart', this.boundAddClasses, { passive: true });
      });

      // Intersection Observer for triggering animation
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              observer.disconnect();
            }
          });
        },
        { threshold: 0.8 }
      );

      observer.observe(this);
    }

    disconnectedCallback() {
      // Clean up all event listeners when component is removed
      this.iconButtons.forEach((btn) => {
        btn.removeEventListener('mousedown', this.boundAddClasses);
        btn.removeEventListener('touchstart', this.boundAddClasses);
      });
      this.removeClasses(); // Cleans up any active listeners
    }

    connectedCallback() {
      this.init();
    }
  }

  customElements.define('image-comparison', ImageComparison);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function repeat(ch, n) { var s = ''; for (var i = 0; i < n; i++) s += ch; return s; }

  function initials(name) {
    var parts = String(name || '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return '?';
    var a = parts[0].charAt(0);
    var b = parts.length > 1 ? parts[parts.length - 1].charAt(0) : '';
    return (a + b).toUpperCase();
  }

  function timeAgo(iso) {
    if (!iso) return '';
    var then = new Date(iso).getTime();
    if (isNaN(then)) return '';
    var s = Math.max(0, (Date.now() - then) / 1000);
    var units = [
      ['year', 31536000], ['month', 2592000], ['week', 604800],
      ['day', 86400], ['hour', 3600], ['minute', 60]
    ];
    for (var i = 0; i < units.length; i++) {
      var v = Math.floor(s / units[i][1]);
      if (v >= 1) return v + ' ' + units[i][0] + (v > 1 ? 's' : '') + ' ago';
    }
    return 'just now';
  }

  function buildStars(value) {
    var wrap = el('span', 'nh-stars');
    var pct = Math.max(0, Math.min(100, (Number(value) / 5) * 100));
    var base = el('span', 'nh-stars__base', '★★★★★');
    var fill = el('span', 'nh-stars__fill', '★★★★★');
    fill.style.width = pct + '%';
    wrap.appendChild(base);
    wrap.appendChild(fill);
    return wrap;
  }

  // JSONP — avoids Apps Script CORS issues.
  function jsonp(url, params) {
    return new Promise(function (resolve, reject) {
      var cb = '__nhcb_' + Math.random().toString(36).slice(2);
      var script = document.createElement('script');
      var timer = setTimeout(function () { cleanup(); reject(new Error('timeout')); }, 15000);
      function cleanup() {
        clearTimeout(timer);
        try { delete window[cb]; } catch (e) { window[cb] = undefined; }
        if (script.parentNode) script.parentNode.removeChild(script);
      }
      window[cb] = function (data) { cleanup(); resolve(data); };
      var q = [];
      for (var k in params) {
        if (params.hasOwnProperty(k)) q.push(encodeURIComponent(k) + '=' + encodeURIComponent(params[k]));
      }
      q.push('callback=' + cb);
      script.src = url + (url.indexOf('?') > -1 ? '&' : '?') + q.join('&');
      script.onerror = function () { cleanup(); reject(new Error('network')); };
      document.body.appendChild(script);
    });
  }

  function initOne(root) {
    if (root.__nhInit) return;
    root.__nhInit = true;

    var cfg = {
      url: root.getAttribute('data-web-app-url') || '',
      productId: root.getAttribute('data-product-id') || '',
      productTitle: root.getAttribute('data-product-title') || '',
      perPage: parseInt(root.getAttribute('data-per-page'), 10) || 6,
      recaptchaKey: root.getAttribute('data-recaptcha-key') || ''
    };

    var $ = function (sel) { return root.querySelector(sel); };
    var els = {
      summary: $('[data-nh-summary]'),
      avg: $('[data-nh-avg]'),
      summaryStars: $('[data-nh-summary-stars]'),
      count: $('[data-nh-count]'),
      openForm: $('[data-nh-open-form]'),
      form: $('[data-nh-form]'),
      cancel: $('[data-nh-cancel]'),
      submit: $('[data-nh-submit]'),
      formMsg: $('[data-nh-form-msg]'),
      rate: $('[data-nh-rate]'),
      ratingInput: $('[data-nh-rating-input]'),
      loading: $('[data-nh-loading]'),
      empty: $('[data-nh-empty]'),
      error: $('[data-nh-error]'),
      list: $('[data-nh-list]'),
      more: $('[data-nh-more]'),
      search: $('[data-nh-search]'),
      sortwrap: $('[data-nh-sortwrap]'),
      sortToggle: $('[data-nh-sort-toggle]'),
      sortMenu: $('[data-nh-sort-menu]'),
      clear: $('[data-nh-clear]'),
      breakdown: $('[data-nh-breakdown]')
    };

    var state = { all: [], filtered: [], shown: 0, sort: 'newest', q: '', ratingFilter: 0 };

    // ---- Form open/close ----
    if (els.openForm && els.form) {
      els.openForm.addEventListener('click', function () {
        els.form.hidden = !els.form.hidden;
        if (!els.form.hidden) els.form.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    }
    if (els.cancel) els.cancel.addEventListener('click', function () { els.form.hidden = true; });

    // ---- Star picker (hollow -> filled) ----
    function paintRate(v) {
      root.querySelectorAll('.nh-rate__star').forEach(function (s) {
        var on = parseInt(s.getAttribute('data-value'), 10) <= v;
        s.textContent = on ? '★' : '☆';
        s.classList.toggle('is-on', on);
      });
    }
    if (els.rate) {
      els.rate.querySelectorAll('.nh-rate__star').forEach(function (star) {
        var v = parseInt(star.getAttribute('data-value'), 10);
        star.addEventListener('click', function () { els.ratingInput.value = v; paintRate(v); });
        star.addEventListener('mouseenter', function () { paintRate(v); });
      });
      els.rate.addEventListener('mouseleave', function () {
        paintRate(parseInt(els.ratingInput.value, 10) || 0);
      });
    }

    // ---- Sort dropdown ----
    function openSort() { if (els.sortMenu) { els.sortMenu.hidden = false; els.sortToggle.setAttribute('aria-expanded', 'true'); } }
    function closeSort() { if (els.sortMenu) { els.sortMenu.hidden = true; els.sortToggle.setAttribute('aria-expanded', 'false'); } }
    if (els.sortToggle) {
      els.sortToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        if (els.sortMenu.hidden) openSort(); else closeSort();
      });
      document.addEventListener('click', function (e) {
        if (els.sortMenu && !els.sortMenu.hidden && els.sortwrap && !els.sortwrap.contains(e.target)) closeSort();
      });
    }
    root.querySelectorAll('[data-nh-sortopt]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.sort = b.getAttribute('data-nh-sortopt');
        applyFilters(); render(); closeSort();
      });
    });
    if (els.clear) els.clear.addEventListener('click', function () {
      state.ratingFilter = 0; state.q = ''; state.sort = 'newest';
      if (els.search) els.search.value = '';
      applyFilters(); render();
    });

    // ---- Search ----
    if (els.search) {
      var t;
      els.search.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () { state.q = els.search.value.trim(); applyFilters(); render(); }, 200);
      });
    }

    // ---- Load more ----
    if (els.more) els.more.addEventListener('click', function () {
      state.shown = Math.min(state.shown + cfg.perPage, state.filtered.length);
      render();
    });

    // ---- Submit ----
    if (els.form) {
      els.form.addEventListener('submit', function (e) {
        e.preventDefault();
        showFormMsg('', null);

        var name = els.form.elements['name'].value.trim();
        var email = els.form.elements['email'].value.trim();
        var rating = parseInt(els.ratingInput.value, 10);
        var body = els.form.elements['body'].value.trim();
        var honeypot = els.form.elements['website'].value;

        if (honeypot) { return; } // bot — stay silent.
        if (!name || !email || !body || !(rating >= 1 && rating <= 5)) {
          showFormMsg('Please complete the rating, name, email, and feedback.', false);
          return;
        }

        var data = new URLSearchParams();
        data.set('name', name);
        data.set('email', email);
        data.set('rating', String(rating));
        data.set('title', '');
        data.set('body', body);
        data.set('product_id', cfg.productId);
        data.set('product_title', cfg.productTitle);
        data.set('website', honeypot);

        if (cfg.recaptchaKey && window.grecaptcha && window.grecaptcha.execute) {
          window.grecaptcha.ready(function () {
            window.grecaptcha.execute(cfg.recaptchaKey, { action: 'submit' }).then(function (token) {
              data.set('g-recaptcha-response', token);
              send(data, { name: name, rating: rating, body: body });
            });
          });
        } else {
          send(data, { name: name, rating: rating, body: body });
        }
      });
    }

    function send(data, optimistic) {
      els.submit.disabled = true;
      showFormMsg('Sending…', null);
      // no-cors: fire-and-forget (Apps Script sends no CORS header). Treat as success unless it errors.
      fetch(cfg.url, { method: 'POST', mode: 'no-cors', body: data })
        .then(function () {
          state.all.unshift({
            id: 'local-' + Date.now(),
            created_at: new Date().toISOString(),
            name: optimistic.name,
            rating: optimistic.rating,
            title: '',
            body: optimistic.body,
            verified: false,
            helpful: 0
          });
          applyFilters();
          render();
          els.form.reset();
          paintRate(0);
          els.form.hidden = true;
          showFormMsg('Thank you! Your review is now live.', true);
          els.submit.disabled = false;
        })
        .catch(function () {
          showFormMsg('Something went wrong. Please try again.', false);
          els.submit.disabled = false;
        });
    }

    function showFormMsg(msg, ok) {
      if (!els.formMsg) return;
      els.formMsg.textContent = msg;
      els.formMsg.hidden = !msg;
      els.formMsg.classList.remove('is-ok', 'is-err');
      if (ok === true) els.formMsg.classList.add('is-ok');
      else if (ok === false) els.formMsg.classList.add('is-err');
    }

    // ---- Data / render ----
    function applyFilters() {
      var arr = state.all.slice();
      if (state.ratingFilter) {
        arr = arr.filter(function (r) { return Math.round(Number(r.rating)) === state.ratingFilter; });
      }
      if (state.q) {
        var q = state.q.toLowerCase();
        arr = arr.filter(function (r) {
          return ((r.body || '') + ' ' + (r.title || '') + ' ' + (r.name || '')).toLowerCase().indexOf(q) > -1;
        });
      }
      switch (state.sort) {
        case 'oldest': arr.sort(function (a, b) { return (a.created_at || '').localeCompare(b.created_at || ''); }); break;
        case 'highest': arr.sort(function (a, b) { return b.rating - a.rating; }); break;
        default: arr.sort(function (a, b) { return (b.created_at || '').localeCompare(a.created_at || ''); });
      }
      state.filtered = arr;
      state.shown = Math.min(cfg.perPage, arr.length);
    }

    function updateSummary() {
      var count = state.all.length;
      var sum = state.all.reduce(function (acc, r) { return acc + (Number(r.rating) || 0); }, 0);
      var avg = count ? (sum / count) : 0;
      if (els.avg) els.avg.textContent = avg.toFixed(2);
      if (els.count) els.count.textContent = 'Based on ' + count + ' review' + (count === 1 ? '' : 's');
      if (els.summaryStars) {
        els.summaryStars.textContent = '';
        els.summaryStars.appendChild(buildStars(avg));
      }
      if (els.summary) els.summary.hidden = (count === 0);
    }

    function renderSortUI() {
      root.querySelectorAll('[data-nh-sortopt]').forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-nh-sortopt') === state.sort);
      });
      if (!els.breakdown) return;
      els.breakdown.textContent = '';
      for (var r = 5; r >= 1; r--) {
        (function (rating) {
          var c = state.all.filter(function (x) { return Math.round(Number(x.rating)) === rating; }).length;
          var row = el('button', 'nh-bdrow');
          row.type = 'button';
          if (state.ratingFilter === rating) row.classList.add('is-active');
          row.appendChild(el('span', 'nh-bdstars', repeat('★', rating)));
          row.appendChild(el('span', 'nh-bdcount', String(c)));
          row.addEventListener('click', function () {
            state.ratingFilter = (state.ratingFilter === rating) ? 0 : rating;
            applyFilters(); render();
          });
          els.breakdown.appendChild(row);
        })(r);
      }
    }

    function buildCard(r) {
      var card = el('div', 'nh-card');

      var head = el('div', 'nh-card__head');
      head.appendChild(el('div', 'nh-card__avatar', initials(r.name)));
      var meta = el('div', 'nh-card__meta');
      if (r.verified) meta.appendChild(el('span', 'nh-badge', 'Verified Customer'));
      meta.appendChild(el('div', 'nh-card__name', r.name || 'Anonymous'));
      head.appendChild(meta);
      card.appendChild(head);

      card.appendChild(buildStars(r.rating));

      if (r.title) card.appendChild(el('div', 'nh-card__title', r.title));
      card.appendChild(el('p', 'nh-card__body', r.body || ''));

      var foot = el('div', 'nh-card__foot');
      foot.appendChild(el('span', 'nh-card__date', timeAgo(r.created_at)));
      card.appendChild(foot);

      return card;
    }

    function render() {
      updateSummary();
      renderSortUI();
      if (!els.list) return;
      els.list.textContent = '';
      var slice = state.filtered.slice(0, state.shown);
      slice.forEach(function (r) { els.list.appendChild(buildCard(r)); });

      if (els.empty) els.empty.hidden = (state.filtered.length !== 0);
      if (els.more) els.more.hidden = (state.shown >= state.filtered.length);
    }

    function showError(msg) {
      if (els.error) { els.error.textContent = msg; els.error.hidden = false; }
    }

    function load() {
      if (!cfg.url) {
        if (els.loading) els.loading.hidden = true;
        showError('Reviews are not configured yet (Web App URL is empty).');
        return;
      }
      jsonp(cfg.url, { product_id: cfg.productId })
        .then(function (res) {
          if (els.loading) els.loading.hidden = true;
          state.all = (res && res.reviews) ? res.reviews : [];
          applyFilters();
          render();
        })
        .catch(function () {
          if (els.loading) els.loading.hidden = true;
          showError('Could not load reviews. Please refresh.');
        });
    }

    load();
  }

  ready(function () {
    document.querySelectorAll('[data-nh-reviews]').forEach(initOne);
  });

  // Theme editor: init a section that was just added/reloaded.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector('[data-nh-reviews]') : null;
    if (root) initOne(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-grid"] && !Shopify.designMode) return;
  try {
    
const productGridInfos = document.querySelectorAll('[data-grid-info]');
productGridInfos.forEach((gridInfo) => {
  const priceDiv = gridInfo.querySelector('.product-price');
  if (priceDiv) {
    const priceHeight = priceDiv.offsetHeight;
    gridInfo.style.setProperty('--product-price-height', `${priceHeight}px`);
  }
});


  } catch(e) { console.error(e); }
})();
})();
